module.exports = __webpack_public_path__ + "static/media/photo-2.bc335379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/crescent-extension/photo-2.jpg
// module id = 157
// module chunks = 0